// import '@comfama/comfama-ui-react/style_important.css';
import "./src/styles/global.css"

export const onClientEntry = () => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v=202510124123';
    document.head.appendChild(link);
};